import { Inject, Injectable } from '@angular/core'
import { Store } from '@ngrx/store'
import { Actions, createEffect, ofType } from '@ngrx/effects'
import { Observable } from 'rxjs'
import { ProjectActions } from './action-types'
import { DialogService } from '../../../../core/services/dialog.service'
import { map, switchMap, take } from 'rxjs/operators'
import { selectSchemaAreaList, selectSchemaLvList } from './project.selectors'

@Injectable()
export class ProjectEffects {

    addArea$: Observable<any>
    addLv$: Observable<any>

    constructor(@Inject(Actions) private actions$: Actions,
                @Inject(DialogService) private dialogService: DialogService,
                @Inject(Store) private store: Store,
                ) {

        this.addArea$ = createEffect(() => this.actions$.pipe(
            ofType(ProjectActions.addArea),
            switchMap((action) => {
                return this.store.select(selectSchemaAreaList).pipe(
                    take(1),
                    map(data => {
                        const areaExists = data.find((a) => {
                            return action.area.katuzeKod === a.katuzeKod
                        })

                        if (areaExists) {
                            this.dialogService.showWarningDialog('Katastrální území je již přidáno v seznamu.')

                            return ProjectActions.noAction()
                        } else {
                            data.push(action.area)

                            return ProjectActions.setSchemaProperty({
                                property: 'areaList',
                                value: data
                            })
                        }
                    })
                )
            })
        ))

        this.addLv$ = createEffect(() => this.actions$.pipe(
            ofType(ProjectActions.addLv),
            switchMap((action) => {
                return this.store.select(selectSchemaLvList).pipe(
                    take(1),
                    map(data => {
                        const lvExists = data.find((l: any) => {
                            return action.lv.katuzeKod === l.katuzeKod && action.lv.lv === l.lv
                        })

                        if (lvExists) {
                            this.dialogService.showWarningDialog('Listina vlastnictví je již přidána v seznamu.')

                            return ProjectActions.noAction()
                        } else {
                            data.push(action.lv)

                            return ProjectActions.setSchemaProperty({
                                property: 'lvList',
                                value: data
                            })
                        }
                    })
                )
            })
        ))
    }
}